import {PublicClientApplication} from "@azure/msal-browser";
import store from "@/store";
import router from "@/routes/router";
import {removeCookie} from "@/cookieUtils";
import {getCurrentI18n} from "@/locales/i18n";

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/' + process.env.VUE_APP_AZURE_TENANT_ID , // Using the v1 endpoint with your own tenant ID
    redirectUri: process.env.VUE_APP_BASE_URL + '/login',
    postLogoutRedirectUri: process.env.VUE_APP_BASE_URL + '/login',
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};
let interactionInProgress = false;
// const locale = {
//   'ru': 'ru-RU',
//   'en': 'en-US',
//   'kk': 'kk-KZ',
// };
export const msalInstance = new PublicClientApplication(msalConfig);

export async function login() {
  if (interactionInProgress) {
    return;
  }
  interactionInProgress = true;
  const loginRequest = {
    scopes: ["openid", "profile", "User.Read"],
    resource: process.env.VUE_APP_AZURE_CLIENT_ID,
    extraQueryParameters: { ui_locales: 'en' }
  };
  try {
    await msalInstance.loginRedirect(loginRequest);
  } catch (error) {
    console.error('Login failed:', error);
  } finally {
    interactionInProgress = false;
  }
}

// export async function logout() {
//   await msalInstance.logoutPopup({
//     mainWindowRedirectUri: "/"
//   });
//   store.dispatch("logout").then(() => {
//   })
// }
export async function logout() {
  try {
    await store.dispatch("logout").then(() =>{
      removeCookie("auth_token");
      // Redirect the user to the logout URL
      window.location.href = `https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=${encodeURIComponent(process.env.VUE_APP_BASE_URL + "/login")}`;
    });
  } catch (error) {
    console.error("Logout failed:", error);
  }
}
export async function checkMicrosoftAuthenticationStatus() {
  try {
    const account = msalInstance.getAllAccounts()[0];
    if (!account) {
      return false;
    }

    await acquireToken();
    return true;
  } catch (error) {
    return false;
  }
}
export async function authenticateWithLaravel(accessToken) {

  try {
    store
      .dispatch("authenticate", {
        access_token: accessToken,
      })
      .then(() => {
        router.push({name: 'main_page', params: { locale: getCurrentI18n() } })
      });
  } catch (error) {
    console.error("Authentication with Laravel failed:", error);
  }
}
export const loginRequest = {
  scopes: ['User.Read'],
};
export async function acquireToken() {
  const account = msalInstance.getAllAccounts()[0];

  if (!account) {
    throw new Error("No accounts found");
  }

  const tokenRequest = {
    scopes: ["User.Read"],
    account: account,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(tokenRequest);
    return response.accessToken;
  } catch (error) {
    console.error("Failed to acquire token silently", error);
    throw error;
  }
}
